import { mainSlider, thumbnailSlider } from './module/estateSlider';

mainSlider.sync( thumbnailSlider );
mainSlider.mount();
thumbnailSlider.mount();